<script>
	import { goto, metatags } from "@roxi/routify";
	import { successToast, warningToast, failureToast } from '../components/toast.js'
	import { getData, postFormData, postJsonData, rootURL } from "../helpers.js";
	import { startAuthentication } from "@simplewebauthn/browser";

	// General Metadata tags
	metatags.title = 'eCPR - Palo Alto Data Group';
	metatags.description = 'Bulk download California eCPR documents automatically with our tool. We can also generate custom data reports such as apprenticeship reports and GPS timecard verification.';

	// Rest of the OpenGraph Metadata tags
	metatags.type = 'website';
	metatags.url = rootURL;
	metatags.image = rootURL + '/ref/index_page.png';

	metatags['twitter:card'] = 'summary_large_image';
	metatags['twitter:url'] = rootURL;
	metatags['twitter:title'] = 'eCPR - Palo Alto Data Group';
	metatags['twitter:description'] = 'Bulk download California eCPR documents automatically with our tool. We can also generate custom data reports such as apprenticeship reports and GPS timecard verification.';
	metatags['twitter:image'] = rootURL + '/ref/index_page.png';

	let tos_accept = false;
	let registerForm;
	let loginForm;

	let usernameRegisterError = '';
	let emailRegisterError = '';
	let passwordRegisterError = '';
	let passwordMatchRegisterError = '';

	let passwordRegisterField; // unused
	let passwordMatchRegisterField; // unused
	// handle register form submission and response
	function handleRegister() {
		let res = postFormData('register', registerForm);
		res.then(response => response.json())
		.then(ret_json => {
			if (ret_json.status === 'success') {
				$goto('./login');
			} else if (ret_json.status === 'error') {
				let errors = ret_json.error;
				usernameRegisterError = errors.username ? errors.username[0] : '';
				emailRegisterError = errors.email ? errors.email[0] : '';
				passwordRegisterError = errors.password ? errors.password[0] : '';
				passwordMatchRegisterError = errors.check_password ? errors.check_password[0] : '';
			}
		});
	}

	function authenticateWebauthn(challenge_id, authn_options, passkey=false) {
		// Pass the options to the authenticator and wait for a response
		let optionsJSON = authn_options
		let response = startAuthentication({ optionsJSON });
		response.catch(error => {
			// Some basic error handling
			if (passkey) passkeyAuthenticateError = error;
			else passwordLoginError = error;
			throw error;
		}).then(asseResp => {
			return postJsonData('webauthn/validate-authentication',
				{'challenge_id': challenge_id, 'options': authn_options, 'asseResp': asseResp})
		}).then(verificationResp => verificationResp.json())
		.then(verificationJson => {
			if (verificationJson && verificationJson.verified) {
				$goto('./dashboard');
			} else {
				let error = `Oh no, something went wrong! Response: ${JSON.stringify(verificationJson)}`
				if (passkey) passkeyAuthenticateError = error;
				else passwordLoginError = error;
			}
		}).catch(error => {
			if (passkey) passkeyAuthenticateError = error;
			else passwordLoginError = error;
		});
	};

	let usernameLoginError = '';
	let passwordLoginError = '';
	// handle login form submission and response
	function handleLogin() {
		let res = postFormData('webauthn/login-webauthn-check', loginForm);
		res.then(response => response.json())
		.then(ret_json => {
			if (ret_json.status === 'success') {
				if (ret_json.webauthn) {
					authenticateWebauthn(ret_json.challenge_id, JSON.parse(ret_json.webauthn_options), false);
				} else {
					$goto('./dashboard');
				}
			} else if (ret_json.status === 'error') {
				let errors = ret_json.error;
				usernameLoginError = errors.username ? errors.username[0] : '';
				passwordLoginError = errors.password ? errors.password[0] : '';
			}
		});
	}

	let passkeyAuthenticateError = '';
	function passkeyAuthenticate() {
		let res = getData('webauthn/authentication-options');
		res.then(response => response.json())
		.then(ret_json => {
			authenticateWebauthn(ret_json.challenge_id, JSON.parse(ret_json.webauthn_options), true);
		}).catch(error => {
			passkeyAuthenticateError = error;
		})
	}

	let passwordlessAuthenticateError = '';
	function passwordlessAuthenticate() {
		let res = postFormData('user/passwordless-login-request', loginForm)
		res.then(response => response.json())
		.then(ret_json => {
			if (ret_json.status === 'success') {
				successToast('If we recognize that information, we\'ve emailed you a login link.');
			} else if (ret_json.status === 'error') {
				let errors = ret_json.error;
				if (typeof(errors) === "string") {
					failureToast(errors);
				} else {
					usernameLoginError = errors.username ? errors.username[0] : '';
				}
			} else {
				failureToast('An unknown error occured.');
			}
		}).catch(error => {
			passwordlessAuthenticateError = error;
		})
	}
</script>

<main class=background>
	<div class="pt-6 pb-3 px-6 text-center text-6xl font-bold font-mono">
		<img class="mx-auto h-44" src="./ref/padg_lockup_panda.svg" alt="Palo Alto Data Group Logo">
	</div>
	<div class="flex max-w-max mx-auto pb-4">
		<div class="inline-flex flex-col px-2 items-center">
			<div class="flex flex-col w-full items-center mx-auto space-y-2 mb-6 font-sans lg:flex-row lg:items-end">
				<div class="inline text-blue-900 text-5xl text-center lg:justify-start lg:text-left">
					<p class="font-bold inline">eCPR</p>
					<p class="font-thin inline">Data Downloader</p>
				</div>
				<div class="text-white text-2xl font-medium text-center lg:ml-auto lg:text-right">
					<p>10¢ FOR EACH DOWNLOAD</p>
				</div>
			</div>
			<div class="flex flex-col justify-center space-y-4 lg:flex-row lg:space-x-4 lg:space-y-0">
				<div class="card px-8 py-8 lg:px-16 lg:py-16 ">
					<p class="text-2xl font-semibold text-blue-900 mb-8">eCPR Search</p>
					<form method="POST" class="flex-col h-full relative box-border" bind:this={loginForm} on:submit|preventDefault={handleLogin}>
						<div class="flex flex-col space-y-6 text-xl h-full box-border">
							<div class='input'>
								<div class="relative">
									<input id="username-login" name="username" placeholder="Username" autocomplete="webauthn username" class="peer z-20 placeholder:text-transparent {usernameLoginError === '' ? '' : 'border-red-600'}"/>
									<label for="username-login" class="absolute text-gray-500 font-normal duration-200 transform -translate-y-4 scale-[.65] top-3 z-10 origin-[0] left-2.5 peer-placeholder-shown:scale-100 peer-placeholder-shown:translate-y-0 peer-placeholder-shown:font-light peer-focus:scale-[.65] peer-focus:-translate-y-4">Username</label>
								</div>
								<p class='error-text {usernameLoginError === '' ? 'hidden' : ''}'>{usernameLoginError}</p>
							</div>
							<div class='input'>
								<div class="relative">
									<input id="password-login" name="password" type="password" placeholder="Password" class="peer z-20 placeholder:text-transparent {passwordLoginError === '' ? '' : 'border-red-600'}"/>
									<label for="password-login" class="absolute text-gray-500 font-normal duration-200 transform -translate-y-4 scale-[.65] top-3 z-10 origin-[0] left-2.5 peer-placeholder-shown:scale-100 peer-placeholder-shown:translate-y-0 peer-placeholder-shown:font-light peer-focus:scale-[.65] peer-focus:-translate-y-4">Password</label>
								</div>
								<p class='error-text {passwordLoginError === '' ? 'hidden' : ''}'>{passwordLoginError}</p>
								<div class="flex justify-end mt-1">
									<a href="/forgot-password" class="text-sm">Forgot Password?</a>
								</div>
							</div>
							<div class="flex space-x-4 !mt-8 justify-between">
								<button type="submit"
									class="w-2/5 pb-3 pt-2 text-xl leading-5 !px-0 rounded-md bg-blue-500 hover:bg-blue-600 cursor-pointer text-gray-100 font-semibold border-none shadow-sm">
									Log In
								</button>
								<!-- <button class="w-3/5 pb-3 pt-2 text-xl leading-5 !px-0 rounded-md bg-blue-500 hover:bg-blue-600 cursor-pointer text-gray-100 font-semibold border-none shadow-sm">
									WebAuthn
								</button> -->
								<div class="tooltip-div">
									<button on:click|preventDefault={passkeyAuthenticate} class="{passkeyAuthenticateError === '' ? 'border-none' : 'border-2 border-red-600'} px-4 pb-3 pt-2 text-xl leading-5 rounded-md bg-blue-500 hover:bg-blue-600 cursor-pointer text-gray-100 font-semibold shadow-sm">
										Passkey
									</button>
									<p class='{passkeyAuthenticateError === '' ? 'hidden' : ''} tooltip'>{passkeyAuthenticateError}</p>
								</div>
							</div>
							<div class="tooltip-div mr-auto mt-8">
								<button on:click|preventDefault={passwordlessAuthenticate} class="{passwordlessAuthenticateError === '' ? 'border-none' : 'border-2 border-red-600'} px-4 pb-3 pt-2 text-xl leading-5 rounded-md bg-blue-500 hover:bg-blue-600 cursor-pointer text-gray-100 font-semibold border-none shadow-sm">
									Passwordless Login
								</button>
								<p class='{passwordlessAuthenticateError === '' ? 'hidden' : ''} tooltip'>{passwordlessAuthenticateError}</p>
							</div>
						</div>
					</form>
				</div>
				<div class="card px-8 py-8 lg:px-16 lg:py-16 ">
					<p class="text-2xl font-semibold text-blue-900 mb-8">Sign up for a new account</p>
					<form method="POST" class="h-full relative" bind:this={registerForm} on:submit|preventDefault={handleRegister}>
						<!-- <input id="csrf_token" name="csrf_token" value="" class="hidden"> -->
						<div class="flex flex-col space-y-6 text-xl">
							<div class="lg:flex lg:space-x-4">
								<div class="block lg:w-1/2">
                                    <div class="input"> <!-- Div here to center properly -->
										<div class="relative">
											<input id="username-register" name="username" placeholder="Username" autocomplete="username" class="peer z-20 placeholder:text-transparent {usernameRegisterError === '' ? '' : 'border-red-600'}"/>
											<label for="username-register" class="absolute text-gray-500 font-normal duration-200 transform -translate-y-4 scale-[.65] top-3 z-10 origin-[0] left-2.5 peer-placeholder-shown:scale-100 peer-placeholder-shown:translate-y-0 peer-placeholder-shown:font-light peer-focus:scale-[.65] peer-focus:-translate-y-4">Username</label>
										</div>
                                        <p class="error-text {usernameRegisterError === '' ? 'hidden' : ''}">{usernameRegisterError}</p>
                                    </div>
								</div>
								<div class="hidden lg:block lg:w-1/2 lg:invisible"></div>
							</div>
							<div class='input'>
								<div class="relative">
									<input id="email-register" name="email" type="email" placeholder="Email Address" autocomplete="email" class="peer z-20 placeholder:text-transparent {emailRegisterError === '' ? '' : 'border-red-600'}"/>
									<label for="email-register" class="absolute text-gray-500 font-normal duration-200 transform -translate-y-4 scale-[.65] top-3 z-10 origin-[0] left-2.5 peer-placeholder-shown:scale-100 peer-placeholder-shown:translate-y-0 peer-placeholder-shown:font-light peer-focus:scale-[.65] peer-focus:-translate-y-4">Email</label>
								</div>
								<p class="error-text {emailRegisterError === '' ? 'hidden' : ''}">{emailRegisterError}</p>
							</div>
							<div>
								<div class="flex flex-col space-y-6 lg:space-y-0 lg:flex-row lg:space-x-4">
									<div class="input lg:w-1/2">
										<div class="relative">
											<input id="password-register" name="password" type="password" placeholder="Password" bind:value={passwordRegisterField} class="peer z-20 placeholder:text-transparent {passwordRegisterError === '' ? '' : 'border-red-600'}"/>
											<label for="password-register" class="absolute text-gray-500 font-normal duration-200 transform -translate-y-4 scale-[.65] top-3 z-10 origin-[0] left-2.5 peer-placeholder-shown:scale-100 peer-placeholder-shown:translate-y-0 peer-placeholder-shown:font-light peer-focus:scale-[.65] peer-focus:-translate-y-4">Password</label>
										</div>
										<p class="error-text {passwordRegisterError === '' ? 'hidden' : ''}">{passwordRegisterError}</p>
									</div>
									<div class="input lg:w-1/2">
										<div class="relative">
											<input id="password-check-register" name="check_password" type="password" placeholder="Verify Password" bind:value={passwordMatchRegisterField} class="peer z-20 placeholder:text-transparent {passwordMatchRegisterError === '' ? '' : 'border-red-600'}"/>
											<label for="password-check-register" class="absolute text-gray-500 font-normal duration-200 transform -translate-y-4 scale-[.65] top-3 z-10 origin-[0] left-2.5 peer-placeholder-shown:scale-100 peer-placeholder-shown:translate-y-0 peer-placeholder-shown:font-light peer-focus:scale-[.65] peer-focus:-translate-y-4">Verify Password</label>
										</div>
										<p class="error-text {passwordMatchRegisterError === '' ? 'hidden' : ''}">{passwordMatchRegisterError}</p>
									</div>
								</div>
							</div>
							<div class="flex space-x-4">
								<input id="accept-rules-register" name="accept_rules" type="checkbox" bind:checked={tos_accept} class="w-8 sm:w-5"/>
								<label for="accept-rules-register" class="flex items-center text-lg">
									<p>I understand and accept the
									<a href="https://docs.google.com/document/d/1fL5hbAqXB2QfShU85-U5i6lwV-k6Zip3rgCoJB2zIEw/edit" class="underline inline">Terms of Service</a>
									and
									<a href="https://docs.google.com/document/d/1bcxTx9Z2zxEWh3yTjsDoiJ6Jr87be6wmFiIb7T8S1qo/edit"class="underline inline">Privacy Policy</a>
									&ZeroWidthSpace;.</p>
								</label>
							</div>
							<input type="submit" disabled={!tos_accept} value="Register"
								class="w-5/12 lg:w-4/12 pb-2 pt-1 !mt-5 !px-0 text-xl rounded-md bg-blue-500 disabled:bg-blue-400 disabled:text-white hover:bg-blue-600 cursor-pointer disabled:hover:cursor-not-allowed text-gray-100 font-semibold border-none shadow-sm">
						</div>
					</form>
				</div>
			</div>
			<div class="flex flex-col w-full items-center space-y-2 lg:flex-row lg:items-end mb-6 mt-2 font-sans">
				<div class="text-center lg:justify-start lg:text-left text-white font-normal">
					<p class="inline-block">A tool to download in bulk from
						<a href="https://www.dir.ca.gov/public-works/certified-payroll-reporting.html" class="font-normal inline underline link-bg-dark">CA.GOV eCPR Search</a>
					</p>
				</div>
				<div class="text-center text-white text-thin font-normal lg:ml-auto lg:text-right">
					<p> * Your continued use constitutes acceptance to our usage of cookies.</p>
				</div>
			</div>
			<div class="flex w-full card py-6">
				<p class="text-blue-900 font-bold text-2xl m-auto text-center">
					Every new account includes a free trial — no card required: contact
					<a href="mailto:support@paloaltodatagroup.com" class="underline inline select-all">support@paloaltodatagroup.com</a>
				</p>
			</div>
			<div class="flex mt-2 font-sans">
				<p class="my-6 m-auto font-medium text-white">Copyright 2021-{new Date().getFullYear()} © Palo Alto Data Group</p>
			</div>
		</div>
	</div>
</main>

<style>
	main.background {
		background:
			radial-gradient(farthest-side at top left,
				rgba(214, 238, 255, 0.773) 5%, transparent 95%),
			/* radial-gradient(farthest-side at bottom right, */
				/* rgba(179, 221, 252, 0.773) 5%, transparent 95%); */
			radial-gradient(farthest-side at bottom right,
				rgba(236, 247, 255, 0.773) 5%, transparent 95%);
		background-color:theme("colors.cust_blue.600");
	}
	.card {
		@apply rounded-md shadow-lg bg-gray-200 bg-opacity-50;
	}
	a.link-bg-dark {
		@apply text-gray-200;
	}
</style>